import React, { PureComponent } from "react";
import styled from "styled-components";
import { colors, shadows } from "../../../../../../ui";

let sparklineIdCounter = 0;

class Sparkline extends PureComponent {
  constructor(props) {
    super(props);
    this.gradientId = `sparklineGradient-${sparklineIdCounter++}`;
  }

  render() {
    const { data, units, type, width, height, tank } = this.props;

    if (!data || data.length < 1) return null; // Not enough data

    let normalizedData = data;
    let normalizedUnits = units;
    let toFixInt = 3;
    if (type === "helium") {
      toFixInt = 2;

      if (units?.toUpperCase() === "LTRS" && tank) {
        normalizedData = data.map((value) => (value / tank) * 100);
        normalizedUnits = "%";
      }
    }

    // Duplicate single data point so a flat line can be drawn
    if (normalizedData.length === 1) {
      normalizedData = [normalizedData[0], normalizedData[0]];
    }

    // Find max and min in data to normalize the y-coordinates
    let maxY = Math.max(...normalizedData);
    let minY = Math.min(...normalizedData);

    // Add offsetCushion (ensures a visible flat line when all values are equal)
    const maxYOffSet = maxY + 0.5;
    const minYOffSet = minY - 0.5;

    // Convert data to SVG path
    const pathData = normalizedData
      .map((value, index) => {
        const x = (width / (normalizedData.length - 1)) * index;
        const y =
          height - (height * (value - minYOffSet)) / (maxYOffSet - minYOffSet);
        return `${x},${y}`;
      })
      .join(" ");

    return (
      <SparklineSC>
        <DataBox>
          <SmallText>Max:</SmallText>{" "}
          <RegularText>{maxY.toFixed(toFixInt)}</RegularText>{" "}
          <UnitText>{normalizedUnits}</UnitText>
        </DataBox>
        <ChartContainer>
          <svg width={width} height={height}>
            <defs>
              <linearGradient
                id={this.gradientId}
                gradientUnits="userSpaceOnUse"
                x1="0"
                y1="0"
                x2={width}
                y2="0"
              >
                <stop
                  offset="0%"
                  stopColor={colors.primary.main}
                  stopOpacity="0.8"
                />
                <stop
                  offset="100%"
                  stopColor={colors.primary.light}
                  stopOpacity="0.6"
                />
              </linearGradient>
            </defs>
            <polyline
              fill="none"
              stroke={`url(#${this.gradientId})`}
              strokeWidth="2"
              points={pathData}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </ChartContainer>
        <DataBox>
          <SmallText>Min:</SmallText>{" "}
          <RegularText>{minY.toFixed(toFixInt)}</RegularText>{" "}
          <UnitText>{normalizedUnits}</UnitText>
        </DataBox>
      </SparklineSC>
    );
  }
}

const SparklineSC = styled.div`
  font-weight: normal;
  color: ${colors.neutral[700]};
  padding: 4px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 2px;

  @media screen and (max-width: 769px) {
    padding: 2px;
    border-radius: 12px;
  }
`;

const ChartContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
`;

const DataBox = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0px;
`;

const SmallText = styled.div`
  display: inline-block;
  min-width: 28px;
  font-size: 10px;
  font-weight: 500;
  color: ${colors.neutral[600]};

  @media screen and (max-width: 769px) {
    min-width: 28px;
    font-size: 11px;
  }
`;

const UnitText = styled.div`
  display: inline-block;
  font-size: 9px;
  color: ${colors.neutral[500]};
  font-weight: 400;
  margin-left: 3px;

  @media screen and (max-width: 769px) {
    font-size: 10px;
  }
`;

const RegularText = styled.div`
  display: inline-block;
  font-weight: 600;
  font-size: 11px;
  color: ${colors.primary.main};

  @media screen and (max-width: 769px) {
    font-size: 12px;
  }
`;
export default Sparkline;
